export const getAllPaymentEp = () =>
    (`/api/transaction`);